import { render, staticRenderFns } from "./Server_Stor.vue?vue&type=template&id=28582384&scoped=true"
import script from "./Server_Stor.vue?vue&type=script&lang=js"
export * from "./Server_Stor.vue?vue&type=script&lang=js"
import style0 from "./Server_Stor.vue?vue&type=style&index=0&id=28582384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28582384",
  null
  
)

export default component.exports